import * as yup from 'yup'

export const createPromoSchema = yup.object({
    code: yup
        .string()
        .required('Code is required')
        .matches(
            /^[A-Z0-9]+$/,
            'Code must be uppercase letters and numbers only'
        ),
    name: yup.string().required('Name is required'),
    description: yup.string(),
    promo_type: yup
        .string()
        .oneOf(['percentage', 'fixed'])
        .required('Type is required'),
    discount_value: yup.number().min(0).required('Discount value is required'),
    max_discount: yup.number().min(0).nullable(),
    currency: yup.string(),
    max_uses: yup.number().min(0).nullable(),
    max_uses_per_customer: yup.number().min(1).default(1),
    valid_from: yup.string(),
    valid_until: yup.string(),
    min_order_amount: yup.number().min(0).nullable(),
    new_customers_only: yup.boolean().default(false),
})
